module.exports = __webpack_public_path__ + "static/media/logo_apple_black.83e0fda4.png";